module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/riben.e73c1cca.mp3";